<template>
  <omk-button
    v-if="whitelabel.omDesign"
    :key="`omk-button-${fill}`"
    @click="btnClicked"
    :disabled="disabled"
    :button-type="computedButtonType"
    :button-size="buttonSize"
    :trailing-icon="trailingIcon"
  >
    {{ title }}
    <omk-icon v-if="buttonIcon" slot="icon">{{ buttonIcon }}</omk-icon>
  </omk-button>
  <div
    v-else
    fluid
    class="gradient-button"
    :class="{ 'stretch-width': stretch }"
  >
    <button
      :disabled="disabled"
      :type="type"
      @click="btnClicked"
      :class="{
        'gradient-button-small': small,
        'no-gradient': !fill,
        'text-align-center': centerText,
        'stretch-width': stretch,
        default: appliedStyle === 'default',
        secondary: appliedStyle === 'secondary',
      }"
    >
      <v-icon
        v-if="callout === 'left' && !loading && !actionCompleted"
        class="gradient-button-icon left"
        >{{ icons.mdiArrowLeft }}</v-icon
      >
      <v-icon
        v-else-if="callout === 'left' && actionCompleted"
        class="gradient-button-icon left"
        >{{ icons.mdiCheck }}</v-icon
      >
      {{ title }}

      <v-icon
        v-if="callout === 'right' && !loading && !actionCompleted"
        class="gradient-button-icon right"
        >{{ icons.mdiArrowRight }}</v-icon
      >
      <v-icon
        v-else-if="callout === 'right' && actionCompleted"
        class="gradient-button-icon right"
        >{{ icons.mdiCheck }}</v-icon
      >
      <v-progress-circular
        v-if="loading"
        class="ml-2"
        :class="!fill ? 'nofill' : ''"
        indeterminate
        color="white"
        size="20"
        :width="2"
      ></v-progress-circular>
    </button>
  </div>
</template>

<script>
import { mdiPlus } from "@mdi/js";
import { mdiArrowRight, mdiArrowLeft, mdiCheck } from "@mdi/js";
export default {
  name: "GradientButton",
  components: {
    mdiArrowRight,
    mdiArrowLeft,
    mdiPlus,
  },
  data() {
    return {
      icons: {
        mdiArrowRight: mdiArrowRight,
        mdiArrowLeft: mdiArrowLeft,
        mdiCheck: mdiCheck,
      },
    };
  },
  props: {
    title: {
      required: true,
      default: "",
      type: String,
    },
    type: {
      required: false,
      default: "button",
      type: String,
    },
    small: {
      required: false,
      default: false,
      type: Boolean,
    },
    fill: {
      required: false,
      default: true,
      type: Boolean,
    },
    callout: {
      required: false,
      default: "right",
      type: String,
    },
    centerText: {
      required: false,
      default: false,
      type: Boolean,
    },
    stretch: {
      required: false,
      default: false,
      type: Boolean,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    loading: {
      required: false,
      default: false,
      type: Boolean,
    },
    actionCompleted: {
      required: false,
      default: false,
      type: Boolean,
    },
    appliedStyle: {
      required: false,
      default: "default",
      type: String,
    },
    buttonType: {
      required: false,
      default: "filled-button",
      type: String,
    },
    buttonSize: {
      required: false,
      default: "medium",
      type: String,
    },
    trailingIcon: {
      required: false,
      default: false,
      type: Boolean,
    },
    buttonIcon: {
      required: false,
      default: "",
      type: String,
    },
  },
  methods: {
    btnClicked() {
      this.$emit("gradientButtonClicked");
    },
  },
  computed: {
    computedButtonType() {
      return this.fill ? "filled-button" : "outlined-button";
    },
    isMobile() {
      return this.$isMobileDevice();
    },
  },
};
</script>

<style scoped lang="scss">
.gradient-button.stretch-width {
  width: 100%;
}

.gradient-button {
  display: inline-block;
  button {
    height: 56px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 18px;
    padding-bottom: 18px;
    white-space: nowrap;

    color: var(--Neutral-White, #fff);
    font-feature-settings: "clig" off, "liga" off;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
    text-transform: uppercase;

    .gradient-button-icon {
      color: var(--Neutral-White, #fff);
      width: 26px;
      height: 26px;
    }
    .gradient-button-icon.right {
      margin-left: 15px;
    }

    .gradient-button-icon.left {
      margin-right: 15px;
    }

    &.gradient-button-small {
      height: 44px !important;
      padding: 10px 18.5px !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 20px !important;
      letter-spacing: 0.005em !important;
      .gradient-button-icon {
        margin-left: 8px !important;
        width: 16px !important;
        height: 16px !important;
      }
    }

    &.no-gradient {
      border-radius: 100px;
      border: 1px solid var(--Light-Button-Stroke, #dcddde) !important;
      background: var(--Light-Button-Colour, #fff) !important;
      color: #282828 !important;
      .gradient-button-icon {
        color: #282828 !important;
      }
    }
    &:disabled {
      background: #dcddde !important;
      color: #a7a9ac !important;
      &:hover {
        box-shadow: none !important;
      }
      ::v-deep {
        .v-icon {
          color: #a7a9ac !important;
        }
      }
    }

    .nofill {
      color: #1e1e1e !important;
    }
  }
  .text-align-center {
    justify-content: center;
  }
  .stretch-width {
    width: 100%;
    justify-content: center;
  }
}
</style>
